// extracted by mini-css-extract-plugin
module.exports = {"supersonicLogo":"logo_supersonicLogo__VaHB9"};